import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { ValidateStudentPayment } from '../state/payment.actions';
import { PaymentState } from '../state/payment.state';

/**
 * Checks to see if a student has already paid or not. If so, they should not be able
 * to activate the associated route
 */
@Injectable({ providedIn: 'root' })
export class PaymentRequiredGuard implements CanActivate {
  constructor(private router: Router, private store: Store) {}

  get hasStudentPaid() {
    return this.store.selectSnapshot(PaymentState.hasStudentPaid);
  }

  canActivate() {
    // Student has definitely already paid no need to check again
    if (this.hasStudentPaid) {
      return true;
    }

    // Whenever student hasn't paid double check if this has changed
    // Note it appears that when directPay is selected, paid will be true
    return this.store.dispatch([new ValidateStudentPayment()]).pipe(
      map(() => {
        if (!this.hasStudentPaid) {
          this.router.navigateByUrl('/payment');
          return false;
        }

        return true;
      })
    );
  }
}
